import { notify } from "shared/ui/Notifications/notify"

/**
 * Says so when an import stored the data but its history entry wasn't written (the import
 * reply's `auditStatus`).
 *
 * @param data - The import reply's body (an object, or the text some replies are)
 */
export const warnIfImportNotRecorded = (data: unknown): void => {
  if (
    typeof data === "object" &&
    data !== null &&
    (data as { auditStatus?: unknown }).auditStatus === "not_recorded"
  )
    notify.error("Import not recorded", "The data was imported, but it is not in the project history.")
}
